import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to top on route change. Mount once near the top of the app inside Router. */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        try {
            window.scrollTo({ top: 0, behavior: "instant" });
        } catch {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
}
